var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrowserNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,21 C13.1825821,21 14.1418396,19.9927734 14.1418396,18.75 L9.85816036,18.75 C9.85816036,19.9927734 10.8174179,21 12,21 Z M19.2116748,15.7367578 C18.5648038,15.0069141 17.3544317,13.9089844 17.3544317,10.3125 C17.3544317,7.58085938 15.5303356,5.39414063 13.0707524,4.85765625 L13.0707524,4.125 C13.0707524,3.50378906 12.591291,3 12,3 C11.408709,3 10.9292476,3.50378906 10.9292476,4.125 L10.9292476,4.85765625 C8.46966435,5.39414063 6.64556832,7.58085938 6.64556832,10.3125 C6.64556832,13.9089844 5.43519622,15.0069141 4.78832516,15.7367578 C4.58743353,15.9635156 4.49837157,16.2345703 4.50002252,16.5 C4.50372868,17.0765625 4.93464124,17.625 5.57481591,17.625 L18.4251841,17.625 C19.0653588,17.625 19.4966061,17.0765625 19.4999775,16.5 C19.5016284,16.2345703 19.4125665,15.9631641 19.2116748,15.7367578 L19.2116748,15.7367578 Z",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserNotifications);
export default __webpack_public_path__ + "static/media/browser-notifications.76e436ac053cd52540dc75f52cc34594.svg";
export { ForwardRef as ReactComponent };